// 命名规则示例数据
export const NAMING_EXAMPLE = {
  user: '王某',
  time: '2020-09-03 20_41_18',
  address: '北京市三里屯',
  watermark: '打卡水印',
  photoNumber: '180-090-1234'
}

// 预设规则数组
export const PRESET_RULE_ARRAY = [
  'user',
  'time',
  'address',
  'watermark',
  'photoNumber'
]

// 默认文件夹层级配置
export const DEFAULT_FOLDER_LEVELS = [
  { level: 1, field: '' },
  { level: 2, field: undefined },
  { level: 3, field: undefined }
]

// 默认命名规则
export const DEFAULT_NAMING_RULE = ['user', 'time', 'watermark']

// 试用次数上限
export const MAX_TRIAL_COUNT = 10

// 本地存储键名
export const STORAGE_KEYS = {
  NAMING_RULE: 'namingRule',
  FOLDER_RULE: 'folderRule',
  FOLDER_TITLES: 'folderTitles',
  MULTI_FOLDER_LAST_SELECTION: 'multiFolder_lastSelection'
}
